import { obtenerProductosInsumos } 
from "../infraestructure/supabase/productosPrecio.repository.js";

export async function obtenerProductosInsumosUseCase() {
  try {
    const insumos = await obtenerProductosInsumos();

    return {
      success: true,
      data: insumos || []
    };

  } catch (error) {

    return {
      success: false,
      error: "[application layer productos] Error al obtener los insumos: " + error.message
    };

  }
}